<template>
<div class="chapter">
<div class="inner_page">
<h1>Inhaltsverzeichnis</h1>
<p><span href="#/c001" title="Link target outside of Sample">Titelseite</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright-Seite</span></p>
<p><a href="#/c003">Glühwürmchen</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Eine Rezension oder Empfehlung macht viel aus!</span></p>
<p><span href="#/c005" title="Link target outside of Sample">Sie sind auf der Suche nach weiteren tollen Leseerlebnissen? | Ihre Bücher in Ihrer Sprache.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?73dd5768